export function getAll() {
  return [
    {
      value: 0,
      name: "Active",
      text: "在職",
    },
    {
      value: 1,
      name: "Resigned",
      text: "離職",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
